/**
 * ReadingEventsContext — thin Provider that mounts the useReadingEvents hook.
 *
 * The data layer is side-effect-only: it observes NowPlayingContext and
 * emits events into the module-level event buffer. This Provider doesn't
 * expose any value to children — it exists so that the hook is mounted
 * exactly once, inside NowPlayingProvider, regardless of which page is
 * currently rendered.
 *
 * Spec: docs/features/assessment-data-layer.md
 */

import { createContext } from 'react';
import { useReadingEvents } from '../hooks/useReadingEvents';

const ReadingEventsContext = createContext(null);

export function ReadingEventsProvider({ children }) {
  // Mounting the hook here means the data layer is always live whenever
  // NowPlayingProvider is mounted. That's the right scope — playback can
  // happen on any route, not just /now-playing, and we want events captured
  // regardless of the current page.
  useReadingEvents();
  return <ReadingEventsContext.Provider value={null}>{children}</ReadingEventsContext.Provider>;
}
